import type { IconSvgObject } from './types';

const MoveDownRightIcon: IconSvgObject = [
  ["path", { d: "M18.5781 12C18.5968 13.3135 19.5004 17.6636 18.5781 18.5859C17.6558 19.5082 13.3057 18.6046 11.9922 18.5859", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5.52252 4.46967C5.22962 4.17678 4.75475 4.17678 4.46186 4.46967C4.16896 4.76256 4.16896 5.23744 4.46186 5.53033L4.99219 5L5.52252 4.46967ZM17.4619 18.5303C17.7548 18.8232 18.2296 18.8232 18.5225 18.5303C18.8154 18.2374 18.8154 17.7626 18.5225 17.4697L17.9922 18L17.4619 18.5303ZM4.99219 5L4.46186 5.53033L17.4619 18.5303L17.9922 18L18.5225 17.4697L5.52252 4.46967L4.99219 5Z", fill: "currentColor", key: "1" }]
];

export default MoveDownRightIcon;
